// extracted by mini-css-extract-plugin
export var infoItem = "_p0-2";
export var title = "_p0-0";
export var value = "_p0-1";